export interface ILateSerology {
    donorId: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenterAlias: string,
    uploadDate: string,
    surgeryDate: string,
    receivedVrl: string,
    daysLate: string,
    uploadBy: string,
    kidneyPickupDateTime: string,
    mostRecentOffer: string
}